import { api } from 'utility';
import {
  getLoanServiceUrl,
  getLoanUserListUrl,
  getUserLoanDetailUrl,
  getLoanSettelmentUrl,
  getLoanInstallment,
  getLoanUserInstallment,
  getLoanPaymentInstallment,
  getLoanDetailUserUrl
} from 'URLs';
class LoanService {
  static async getLoanList(params) {
    return api.get(getLoanServiceUrl(), { params }).then((res) => res.data);
  }

  static async getUserLoanList(params) {
    return api.get(getLoanUserListUrl(), { params }).then((res) => res.data);
  }

  static async getLoanDetails(id) {
    return api.get(getLoanDetailUserUrl(id)).then((res) => res.data);
  }
  
  static async getUserLoanDetails(id) {
    return api.get(getUserLoanDetailUrl(id), {}).then((res) => res.data);
  }

  static async getInstallmentList(params) {
    return api.get(getLoanInstallment(), { params }).then((res) => res.data);
  }

  static async getUserInstallmentList(params) {
    return api.get(getLoanUserInstallment(), { params }).then((res) => res.data);
  }

  static async retryToPayInstallment(installmentId) {
    return api.post(getLoanPaymentInstallment(), { installmentId }).then((res) => res.data);
  }

  static async getUserInstallment(params) {
    return api.get(getLoanUserInstallment(), { params });
  }

  static async loanPerSettlement(loanId) {
    return api.post(getLoanSettelmentUrl(), { loanId });
  }
}

export default LoanService;
